import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { DSText } from '@engenharia/ds-react';
import CircularProgress from '@material-ui/core/CircularProgress';

import { getMagicLinkParams, verifyMagicLink } from '../../services/magicLinkVerify';
import Header from '../../components/Header';
import Logo from '../../components/molecules/Logo';
import { Page, Content, LogoImage, StatusRow } from './styles';

export default function MagicLinkVerify() {
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [isVerifying, setIsVerifying] = useState(true);
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (hasStartedRef.current) return undefined;
    hasStartedRef.current = true;

    const controller = new AbortController();
    let cancelled = false;

    const { token, email, source } = getMagicLinkParams();

    if (!token || !email) {
      setIsVerifying(false);
      setError(t('errors.connection-failure'));
      return undefined;
    }

    verifyMagicLink({ token, email, source, signal: controller.signal }).catch((err) => {
      if (cancelled || axios.isCancel(err)) return;

      setIsVerifying(false);
      const message = err?.response?.data?.message || t('errors.connection-failure');
      setError(message);
    });

    return () => {
      cancelled = true;
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header positionFixed />
      <Page>
        <Content>
          <Logo fullWidth imgComponent={LogoImage} />
          {error && (
            <DSText variant="body1" color="warning" style={{ marginTop: 24, textAlign: 'center' }}>
              {error}
            </DSText>
          )}
          {!error && isVerifying && (
            <StatusRow>
              <CircularProgress size="16px" />
              <DSText variant="body2" color="textSecondary">
                {t('magicLinkVerify.verifying')}
              </DSText>
            </StatusRow>
          )}
        </Content>
      </Page>
    </>
  );
}
